import React from 'react';
import { useTranslation } from 'react-i18next';
import StyledButton from './StyledButton';
import styled from '@emotion/styled';

const StyledCancelButton = styled(StyledButton)({
  color: "#181818",
  borderColor: "#d1d1d1",
  "&:hover": {
    backgroundColor: "#f7f7f7",
  },

  fontWeight: 400,
  fontSize: "12.5px",
  fontFamily: "Fira Sans, Helvetica Neue, Helvetica, Roboto, Arial, sans-serif",
});

const CancelButton = ({ children, ...props }) => {
  const { t } = useTranslation('buttons');

  return (
    <StyledCancelButton {...props}>
      {children || t('secondary.cancel')}
    </StyledCancelButton>
  );
};

export default CancelButton;